import { Factory } from 'rosie';

Factory.define('RecommendedAnswerCount');

Factory.define('RecommendedAnswerCountWithDefaults')
  .extend('RecommendedAnswerCount')
  .attr('id', 'default-id')
  .attr('count', 5);

Factory.define('RecommendedAnswersCounts');

Factory.define('RecommendedAnswersCountsWithDefaults')
  .extend('RecommendedAnswersCounts')
  .attr('counts', [Factory.attributes('RecommendedAnswerCountWithDefaults')]);
